// Helper pour envoyer des événements à Google Analytics 4 (gtag).
// gtag est injecté par le composant SEOTracking si google_analytics_id est configuré.
// Si GA n'est pas chargé (dev, ou ID absent), l'appel est ignoré silencieusement.

export function trackEvent(name, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
}
